<div class="page-container" [class.loading]="isLoading">
    <app-header
        [title]="
            'benefits.benefitsPayroll.monthlyBill'
                | translate
                    : {
                          date: benefitInvoice.period | appDate: 'MMM, YYYY',
                          provider: benefitInvoice.benefitProvider.name,
                      }
        "
        [back]="true"
        [backRoute]="['/benefits', 'settings']"
    >
        @if (status === 'unsynced') {
            <div class="buttons">
                <ui-button type="primary" (click)="sync()" [disabled]="route.snapshot.data.isPayrollPending">{{
                    'benefits.benefitsPayroll.syncToPayrollBtn' | translate
                }}</ui-button>
            </div>
        }
    </app-header>

    @if (route.snapshot.data.isPayrollPending) {
        <ui-banner class="margin-bottom-4" [variant]="'warning'">
            <p class="flag-content">{{ 'benefits.benefitsPayroll.pendingPayrollNotice' | translate }}</p>
        </ui-banner>
    }

    <ui-card>
        <app-header [title]="'benefits.benefitsPayroll.monthlyStatement'"> </app-header>
        <br />

        @if (status === 'unsynced') {
            <app-benefit-invoice-unmapped-employees [benefitInvoice]="benefitInvoice" />
            <br />
        }

        <div class="grid-row">
            <div class="flex col">
                <div class="title">{{ 'benefits.benefitsPayroll.benefitsProvider' | translate }}</div>
                <div class="margin-top-1">{{ benefitInvoice.benefitProvider.name }}</div>
            </div>

            <div class="flex col">
                <div class="title">{{ 'benefits.benefitsPayroll.timePeriod' | translate }}</div>
                <div class="margin-top-1">{{ benefitInvoice.period | appDate: 'MMM, y' }}</div>
            </div>

            <div class="flex col">
                <div class="title">{{ 'benefits.benefitsPayroll.syncToPayroll' | translate }}</div>
                <div class="margin-top-1">
                    <ui-badge [type]="syncType" [attr.aria-label]="'benefits.benefitsPayroll.syncStatus' | translate">{{
                        benefitInvoiceStatusDisplayOptions[status] ?? status | translate
                    }}</ui-badge>
                </div>
            </div>
        </div>
    </ui-card>
</div>
